import { render, staticRenderFns } from "./especialidade.vue?vue&type=template&id=1c3eb850"
import script from "./especialidade.vue?vue&type=script&lang=js"
export * from "./especialidade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports